import { VAULT_PAYOUT_CYCLE_DAYS, VAULT_PAYOUT_END_DATE } from "@/constants/const";
import { getNextCycleDate, getTimeRemaining } from "@/hook/useCycleCountdown";

export const getVaultPayoutCountdown = (nowMs: number): string => {
  if (!VAULT_PAYOUT_END_DATE) return "Pending";

  const nextPayout = getNextCycleDate(VAULT_PAYOUT_END_DATE, VAULT_PAYOUT_CYCLE_DAYS, nowMs);
  const { days, hours, minutes, seconds } = getTimeRemaining(nextPayout, nowMs);
  const hh = String(hours).padStart(2, "0");
  const mm = String(minutes).padStart(2, "0");
  const ss = String(seconds).padStart(2, "0");

  return days > 0 ? `${days}d ${hh}:${mm}:${ss}` : `${hh}:${mm}:${ss}`;
};
